var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "toast toast--success",
    class: 'toast--' + _vm.variant
  }, [_c('div', {
    staticClass: "toast__icon"
  }, [_vm.variant === 'success' ? [_c('svg', {
    attrs: {
      "width": "15",
      "height": "15",
      "viewBox": "0 0 15 15",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7.53678 10.4405L7.53743 10.4395L9.53809 5.16309L9.45326 5.11014L9.4532 5.11023C9.45317 5.11027 9.45315 5.11031 9.45312 5.11035L6.8837 9.22673L5.72143 7.72785C5.63949 7.61637 5.55295 7.53958 5.45608 7.49166C5.35878 7.44354 5.25866 7.42832 5.15625 7.42832C4.80453 7.42832 4.53672 7.70809 4.53672 8.06152C4.53672 8.23079 4.60115 8.39634 4.71674 8.53523C4.71687 8.53539 4.71699 8.53554 4.71712 8.5357L6.27437 10.4481C6.36538 10.5645 6.46071 10.6518 6.56841 10.7097C6.67728 10.7682 6.7931 10.7934 6.91992 10.7934C7.17694 10.7934 7.39105 10.663 7.53678 10.4405ZM7.62402 14.348C11.3023 14.348 14.348 11.3023 14.348 7.62402C14.348 3.94561 11.2953 0.9 7.61719 0.9C3.94568 0.9 0.9 3.94582 0.9 7.62402C0.9 11.3023 3.94575 14.348 7.62402 14.348ZM7.62402 12.9791C4.65801 12.9791 2.28262 10.5974 2.28262 7.62402C2.28262 4.65052 4.65134 2.26895 7.61719 2.26895C10.5902 2.26895 12.9724 4.65094 12.9791 7.62425C12.9858 10.597 10.5973 12.9791 7.62402 12.9791Z",
      "fill": "#00C853",
      "stroke": "#00C853",
      "stroke-width": "0.2"
    }
  })])] : _vm._e(), _vm.variant === 'error' ? [_c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 14 14",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7 0C3.13306 0 0 3.16129 0 7C0 10.8669 3.13306 14 7 14C10.8387 14 14 10.8669 14 7C14 3.16129 10.8387 0 7 0ZM7 12.6452C3.86694 12.6452 1.35484 10.1331 1.35484 7C1.35484 3.89516 3.86694 1.35484 7 1.35484C10.1048 1.35484 12.6452 3.89516 12.6452 7C12.6452 10.1331 10.1048 12.6452 7 12.6452ZM8.18548 9.70968C8.18548 9.06048 7.64919 8.52419 7 8.52419C6.32258 8.52419 5.81452 9.06048 5.81452 9.70968C5.81452 10.3871 6.32258 10.8952 7 10.8952C7.64919 10.8952 8.18548 10.3871 8.18548 9.70968ZM5.87097 3.75403L6.06855 7.59274C6.06855 7.7621 6.2379 7.90323 6.40726 7.90323H7.56452C7.73387 7.90323 7.90323 7.7621 7.90323 7.59274L8.10081 3.75403C8.10081 3.55645 7.95968 3.3871 7.7621 3.3871H6.20968C6.0121 3.3871 5.87097 3.55645 5.87097 3.75403Z",
      "fill": "#DE0071"
    }
  })])] : _vm._e(), _vm.variant === 'warning' ? [_c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 14 14",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7 0C3.13306 0 0 3.16129 0 7C0 10.8669 3.13306 14 7 14C10.8387 14 14 10.8669 14 7C14 3.16129 10.8387 0 7 0ZM7 12.6452C3.86694 12.6452 1.35484 10.1331 1.35484 7C1.35484 3.89516 3.86694 1.35484 7 1.35484C10.1048 1.35484 12.6452 3.89516 12.6452 7C12.6452 10.1331 10.1048 12.6452 7 12.6452ZM8.18548 9.70968C8.18548 9.06048 7.64919 8.52419 7 8.52419C6.32258 8.52419 5.81452 9.06048 5.81452 9.70968C5.81452 10.3871 6.32258 10.8952 7 10.8952C7.64919 10.8952 8.18548 10.3871 8.18548 9.70968ZM5.87097 3.75403L6.06855 7.59274C6.06855 7.7621 6.2379 7.90323 6.40726 7.90323H7.56452C7.73387 7.90323 7.90323 7.7621 7.90323 7.59274L8.10081 3.75403C8.10081 3.55645 7.95968 3.3871 7.7621 3.3871H6.20968C6.0121 3.3871 5.87097 3.55645 5.87097 3.75403Z",
      "fill": "#ed6c00"
    }
  })])] : _vm._e()], 2), _vm._t("default")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }